<div class="wrapper" [style.maxWidth]="maxWidth | px">
  <svg [icon]="icon" class="error-svg mb32"></svg>
  <strong  *ngIf="header" class="h3 mb12">{{ header | translate }}</strong>
  <span *ngIf="message" class="body-2 mb12">{{ message | translate }}</span>
  <ng-content></ng-content>
</div>
